import { Injectable } from '@angular/core';
import { FileItem } from '../document-upload/file-item';
import { StorageName } from '../document-upload/storage-name.enum';
import { ApiService } from './api/api.service';

@Injectable()
export class FileService {
    constructor(private apiService: ApiService) {}

    read(dir?: string) {
        return this.apiService.getCall$<FileItem[]>(`file-manager/read`, { dir });
    }

    delete(path: string | FileItem, storage?: StorageName) {
        if (path instanceof FileItem) {
            return this.apiService.deleteCall$('file-manager', { path: path.path, secure: storage });
        }
        return this.apiService.deleteCall$('file-manager', { path, secure: storage });
    }

    rotateImage(path?: string, root?: boolean, secure?: string) {
        if (path.substr(0, 7) === '/media/') {
            path = path.substr(6);
        }
        if (root) {
            return this.apiService.getCall$<FileItem>(`file-manager/rotate-image`, { path, root, secure });
        }
        return this.apiService.getCall$<FileItem>(`file-manager/rotate-image`, { path, secure });
    }
}
